/* gr-calendar-reminder.js
   Adds a calendar icon button that opens a small picker (days + time)
   and downloads a recurring weekly .ics reminder to visit Great Reminders.
*/
(function () {
  const PLAYBOOK_URL = "https://greatreminders.com/pages/my-playbook"; // <-- change this
  const EVENT_TITLE = "Great Reminders - Leadership Check-In";
  const EVENT_DESC =
    "Leadership check-in. Revisit your chosen frameworks in the Playbook and apply one in a real moment today.";

  const WEEKDAYS = [
    { key: "MO", label: "Mon", idx: 1 },
    { key: "TU", label: "Tue", idx: 2 },
    { key: "WE", label: "Wed", idx: 3 },
    { key: "TH", label: "Thu", idx: 4 },
    { key: "FR", label: "Fri", idx: 5 },
    { key: "SA", label: "Sat", idx: 6 },
    { key: "SU", label: "Sun", idx: 0 },
  ];

  // ---------- helpers ----------
  const pad2 = (n) => String(n).padStart(2, "0");

  function toICSLocalDateTime(d) {
    // Floating local time: YYYYMMDDTHHMMSS (no Z)
    return (
      d.getFullYear() +
      pad2(d.getMonth() + 1) +
      pad2(d.getDate()) +
      "T" +
      pad2(d.getHours()) +
      pad2(d.getMinutes()) +
      "00"
    );
  }

  function toICSUTCDateTime(d) {
    // UTC: YYYYMMDDTHHMMSSZ
    return (
      d.getUTCFullYear() +
      pad2(d.getUTCMonth() + 1) +
      pad2(d.getUTCDate()) +
      "T" +
      pad2(d.getUTCHours()) +
      pad2(d.getUTCMinutes()) +
      pad2(d.getUTCSeconds()) +
      "Z"
    );
  }

  function escapeICS(text) {
    // ICS escaping: backslash, comma, semicolon, newline
    return String(text)
      .replace(/\\/g, "\\\\")
      .replace(/,/g, "\\,")
      .replace(/;/g, "\\;")
      .replace(/\r?\n/g, "\\n");
  }

  function nextOccurrence(selectedByDayIdx, timeHHMM) {
    const [hh, mm] = timeHHMM.split(":").map((x) => parseInt(x, 10));
    const now = new Date();

    // Search the next 14 days to find the next selected weekday at the chosen time
    for (let add = 0; add < 14; add++) {
      const d = new Date(now);
      d.setDate(now.getDate() + add);
      d.setHours(hh, mm, 0, 0);

      const dayIdx = d.getDay(); // 0 Sun .. 6 Sat
      if (!selectedByDayIdx.has(dayIdx)) continue;

      // If it's today, only allow if time is still in the future
      if (add === 0 && d.getTime() <= now.getTime()) continue;

      return d;
    }

    // Fallback: next week same time
    const fallback = new Date(now);
    fallback.setDate(now.getDate() + 7);
    fallback.setHours(hh, mm, 0, 0);
    return fallback;
  }

  function buildICS({ bydayKeys, dtstartLocal }) {
    const uid = "gr-" + Math.random().toString(16).slice(2) + "@greatreminders";
    const dtstamp = toICSUTCDateTime(new Date());

    const description = `${EVENT_DESC}\n\nPlaybook: ${PLAYBOOK_URL}`;

    // Weekly recurring rule
    const rrule = `FREQ=WEEKLY;BYDAY=${bydayKeys.join(",")}`;

    // Note: many calendar apps accept floating DTSTART without TZ. Keeps it simple for Shopify.
    const ics =
      [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//Great Reminders//Calendar Reminder//EN",
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VEVENT",
        `UID:${uid}`,
        `DTSTAMP:${dtstamp}`,
        `DTSTART:${toICSLocalDateTime(dtstartLocal)}`,
        `RRULE:${rrule}`,
        `SUMMARY:${escapeICS(EVENT_TITLE)}`,
        `DESCRIPTION:${escapeICS(description)}`,
        `URL:${escapeICS(PLAYBOOK_URL)}`,
        "TRANSP:OPAQUE",
        "END:VEVENT",
        "END:VCALENDAR",
      ].join("\r\n") + "\r\n";

    return ics;
  }

  function downloadICS(icsText, filename = "great-reminders-checkin.ics") {
    const blob = new Blob([icsText], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1500);
  }

  // ---------- UI ----------
  function ensureStyles() {
    if (document.getElementById("gr-cal-styles")) return;
    const css = `
        .gr-cal-btn{
        display:inline-flex; align-items:center; justify-content:center;
        gap:6px;
        height:32px;
        padding:0 14px;
        width:auto;
        border-radius:999px;
        border:1px solid #c7dcff;
        background:#f5f9ff;
        color:#0b5cab;
        cursor:pointer;
        transition: all .18s ease;
        }
        .gr-cal-btn:hover{
        background:#e8f2ff;
        border-color:#9ec5fe;
        transform: translateY(-1px);
        box-shadow:0 4px 10px rgba(11,92,171,.12);
        }
        .gr-cal-btn svg{
        width:16px; height:16px;
        fill:none; stroke:#0b5cab; stroke-width:2;
        }
        .gr-cal-label{
            font-weight:700;
            font-size:13px;
            color:#0b5cab;
            }



      .gr-cal-modal-backdrop{
        position:fixed; inset:0; background:rgba(15,23,42,.45);
        display:flex; align-items:center; justify-content:center;
        z-index:9999; padding:18px;
      }
      .gr-cal-modal{
        width:min(520px, 100%);
        background:#fff; border-radius:16px; border:1px solid #e2e8f0;
        box-shadow: 0 18px 50px rgba(15,23,42,.18);
        padding:16px;
      }
      .gr-cal-title{ font-weight:800; color:#0f172a; font-size:16px; margin:0 0 4px; }
      .gr-cal-sub{ color:#64748b; font-size:13px; margin:0 0 12px; line-height:1.45; }
      .gr-cal-row{ display:flex; gap:10px; flex-wrap:wrap; margin:10px 0; }
      .gr-cal-days{ display:flex; gap:8px; flex-wrap:wrap; }
      .gr-cal-day{
        display:inline-flex; align-items:center; gap:6px;
        border:1px solid #dbe3ee; border-radius:999px; padding:6px 10px;
        font-size:13px; font-weight:700; color:#0b1f44; cursor:pointer;
        user-select:none;
      }
      .gr-cal-day input{ accent-color:#0073e6; }
      .gr-cal-time{
        border:1px solid #dbe3ee; border-radius:12px; padding:10px 12px;
        font-size:14px;
      }
      .gr-cal-actions{ display:flex; gap:10px; justify-content:flex-end; margin-top:14px; }
      .gr-cal-primary{
        border:0; background:#0073e6; color:#fff; font-weight:800;
        padding:10px 12px; border-radius:12px; cursor:pointer;
      }
      .gr-cal-secondary{
        border:1px solid #dbe3ee; background:#fff; color:#0f172a; font-weight:800;
        padding:10px 12px; border-radius:12px; cursor:pointer;
      }
      .gr-cal-hint{ font-size:12px; color:#64748b; margin-top:10px; }
    `;
    const style = document.createElement("style");
    style.id = "gr-cal-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function calendarIconSVG() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 2v3M17 2v3M3.5 9.5h17M5 5.5h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2Z"/>
        <path d="M7 13h3M7 16h3M12 13h3M12 16h3"/>
      </svg>
    `;
  }

  function openModal() {
    ensureStyles();

    const backdrop = document.createElement("div");
    backdrop.className = "gr-cal-modal-backdrop";

    const modal = document.createElement("div");
    modal.className = "gr-cal-modal";

    const defaultDays = new Set([1, 2, 3, 4, 5]); // Mon-Fri default
    const defaultTime = "08:30";

    modal.innerHTML = `
      <div class="gr-cal-title">Set a recurring reminder</div>
      <div class="gr-cal-sub">
        Choose the days + time you want a recurring check-in to visit your Playbook.
      </div>

      <div class="gr-cal-row">
        <div style="font-weight:800;color:#0f172a;font-size:13px;">Days</div>
        <div class="gr-cal-days" id="gr-cal-days"></div>
      </div>

      <div class="gr-cal-row" style="align-items:center;">
        <div style="font-weight:800;color:#0f172a;font-size:13px;">Time</div>
        <input class="gr-cal-time" id="gr-cal-time" type="time" value="${defaultTime}" />
      </div>

      <div class="gr-cal-actions">
        <button class="gr-cal-secondary" type="button" id="gr-cal-cancel">Cancel</button>
        <button class="gr-cal-primary" type="button" id="gr-cal-download">Add to calendar</button>
      </div>

      <div class="gr-cal-hint">
        This downloads an <strong>.ics</strong> file you can import into Outlook, Google Calendar, Apple Calendar, etc.
      </div>
    `;

    backdrop.appendChild(modal);
    document.body.appendChild(backdrop);

    const daysWrap = modal.querySelector("#gr-cal-days");
    WEEKDAYS.forEach((d) => {
      const pill = document.createElement("label");
      pill.className = "gr-cal-day";
      pill.innerHTML = `<input type="checkbox" data-idx="${d.idx}" data-key="${d.key}"> ${d.label}`;
      const cb = pill.querySelector("input");
      if (defaultDays.has(d.idx)) cb.checked = true;
      daysWrap.appendChild(pill);
    });

    function close() {
      backdrop.remove();
    }

    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) close();
    });
    modal.querySelector("#gr-cal-cancel").addEventListener("click", close);

    modal.querySelector("#gr-cal-download").addEventListener("click", () => {
      const time = modal.querySelector("#gr-cal-time").value || defaultTime;

      const selected = Array.from(modal.querySelectorAll('input[type="checkbox"][data-key]'))
        .filter((x) => x.checked)
        .map((x) => ({ key: x.dataset.key, idx: parseInt(x.dataset.idx, 10) }));

      if (!selected.length) {
        alert("Select at least one day.");
        return;
      }

      const bydayKeys = selected.map((s) => s.key);
      const idxSet = new Set(selected.map((s) => s.idx));
      const dtstartLocal = nextOccurrence(idxSet, time);

      const ics = buildICS({ bydayKeys, dtstartLocal });
      downloadICS(ics);
      close();
    });
  }

  function mountButton() {
    // Add the button wherever you place this placeholder:
    // <span class="gr-calendar-reminder"></span>
    const mount = document.querySelector(".gr-calendar-reminder");
    if (!mount) return;

    ensureStyles();

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "gr-cal-btn";
    btn.setAttribute("aria-label", "Add recurring reminder to visit Great Reminders");
    const label = mount.getAttribute("data-label") || "";
    btn.innerHTML = calendarIconSVG() + (label ? `<span class="gr-cal-label">${label}</span>` : "");


    btn.addEventListener("click", openModal);
    mount.appendChild(btn);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountButton);
  } else {
    mountButton();
  }
})();
